import { render, staticRenderFns } from "./BrbPagination.vue?vue&type=template&id=82a8a250&"
import script from "./BrbPagination.vue?vue&type=script&lang=js&"
export * from "./BrbPagination.vue?vue&type=script&lang=js&"
import style0 from "./BrbPagination.vue?vue&type=style&index=0&id=82a8a250&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a8a250')) {
      api.createRecord('82a8a250', component.options)
    } else {
      api.reload('82a8a250', component.options)
    }
    module.hot.accept("./BrbPagination.vue?vue&type=template&id=82a8a250&", function () {
      api.rerender('82a8a250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbPagination.vue"
export default component.exports